import React from "react";
import PT from "prop-types";
import { Link } from "@quintype/components";
import "./menu-item.m.css";

import { RESET_ALL_RADIO_PLAYERS } from "../../store/actions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import get from "lodash/get";

const MenuItem = ({ item, toggleHandler, menuStyle = "menu-link", navSelected, setNavSelected }) => {
  const dispatch = useDispatch();

  const iconCode = get(item, ["data", "icon_code"], "") || get(item, ["icon-code"], "") || "";
  const color = get(item, ["data", "color"], null);
  const isRadioTrigger = iconCode === "radio-menu"; // Restore this logic
  const getUrl = (item) => {
    if (item["item-type"] === "section") {
      return item.url || `/${item["section-slug"]}`;
    }
    if (item["item-type"] === "tag") {
      return item.url || `/topic/${item["tag-slug"]}`;
    }
    if (item["item-type"] === "link") {
      return item.completeUrl || item.url || "/";
    }
    return "/";
  };

  if (item["item-type"] === "placeholder" && isRadioTrigger) {
    return (
      <Link href="/radiot">
        <div styleName={menuStyle} onClick={toggleHandler} className={menuStyle}>
          <span
            onClick={() => {
              setNavSelected("radiot");
              dispatch({ type: RESET_ALL_RADIO_PLAYERS });
            }}
            styleName={`menu-link nav-item-kanavat ${navSelected === "radiot" ? "active" : ""}`}
            style={color ? { color: color } : {}}
          >
            {item.title}
          </span>
        </div>
      </Link>
    );
  }else if (item["item-type"] === "placeholder") {
    return (
      <div styleName={menuStyle} className={menuStyle}>
        <span styleName={`menu-link nav-item-kanavat`} style={color ? { color: color } : {}}>
          {item.title}
        </span>
      </div>
    );
  } else {
    return (
      <Link aria-label="menu-item" callback={toggleHandler} className={menuStyle} href={getUrl(item)}>
        <span
          styleName={`${menuStyle} nav-item-kanavat ${
            navSelected && navSelected.toLowerCase() === item.title.toLowerCase() ? "active" : ""
          }`}
          onClick={() => {
            setNavSelected(item.title);
            dispatch({ type: RESET_ALL_RADIO_PLAYERS });
          }}
          style={color ? { color: color } : {}}
        >
          {item.title}
        </span>
      </Link>
    );
  }
};

MenuItem.propTypes = {
  item: PT.object,
  showIcon: PT.bool,
};

export { MenuItem };
